import React, {useEffect} from "react";
import {Button, Divider, Modal} from "antd";
import {useState} from "react";
import {Comment} from "../utils/interfaces";
import {BASE_URL} from "../utils/constants";
import axios from "axios";
import TextArea from "antd/es/input/TextArea";
import { NotificationInstance } from "antd/es/notification/interface";

interface Props{
    showModal: boolean,
    onClose: () => void,
    commentTarget: string,
    targetId: number,
    targetObject: any,
    api: NotificationInstance
}

const CommentsComponent : React.FC<Props> = ({showModal,onClose, commentTarget, targetId, targetObject, api}) => {
    const [commentsList, setCommentsList] = useState<Comment[]>([])
    const [newComment, setNewComment] = useState<string>("")

    useEffect(()=>{
        setNewComment("");
        if(showModal){
            axios.post(BASE_URL + 'get_comments',{
                target: commentTarget,
                target_id: targetId
            })
                .then(function (response) {
                    console.log(response)
                    setCommentsList(response.data.content)
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    },[targetId,commentTarget, showModal]);

    const handleInputChange = (e:any) => {
        setNewComment(e.target.value);
    }
    const handleAddComment = () => {
        const newCommentObject = {
            target: commentTarget,
            target_id: targetId,
            comment: newComment
        }

        axios.post(BASE_URL + 'add_comment',newCommentObject)
            .then(function (response) {
                console.log(response)
                setNewComment('');
                onClose();
                api.success({
                    title: "Comment Added",
                    description: `Your comment was added successfully.`,
                    placement: "bottomRight",
                    showProgress: true
                });
            })
            .catch(function (error) {
                console.log(error)
                api.error({
                    title: "Error Adding Comment",
                    description: `There was an error adding your comment: ${error.message}`,
                    placement: "bottomRight",
                    showProgress: true
                });
            })
    }
    const comments = commentsList.map((comment) =>
        <>
        <li>{comment.formatted_comment}</li>
        <Divider/>
        </>

    ).reverse();
    return(
        <Modal footer={null} open={showModal}  onCancel={onClose} title={"Comments"}>
            <div style={{marginBottom: 16}} >
                <TextArea
                    value={newComment}
                    onChange={(e) => handleInputChange(e)}
                    placeholder="Add a comment"
                />
                <Button onClick={handleAddComment} >Add Comment</Button>
            </div>
            <ul>
                {comments}
            </ul>
        </Modal>
    )
}
export default CommentsComponent;